import _extends from "@babel/runtime/helpers/extends";
import { useBanner, bannerHeaderInlineStyleContainer, bannerHeaderInlineStyle, bannerHeaderInlineStyleLogo, commonInlineStyleHeaderHeadline, BannerCloseIcon } from "../../..";
import { forwardRef } from "react"; // eslint-disable-next-line react/display-name

const BannerHeader = /*#__PURE__*/forwardRef((_, ref) => {
  const banner = useBanner();
  const {
    headerDesign: {
      logo,
      logoRetina
    },
    decision: {
      showCloseIcon
    },
    texts: {
      headline
    },
    activeAction,
    individualPrivacyOpen,
    individualTexts,
    i18n: {
      headerTitlePrivacyPolicyHistory
    }
  } = banner; // Calculate logo

  const useRetina = logoRetina && !(logo !== null && logo !== void 0 && logo.endsWith(".svg")) && window.devicePixelRatio > 1;
  const useLogo = useRetina ? logoRetina : logo; // Calculate headline

  const useHeadline = individualPrivacyOpen ? activeAction === "history" ? headerTitlePrivacyPolicyHistory : individualTexts.headline : headline;
  return h("div", _extends({
    ref: ref
  }, bannerHeaderInlineStyleContainer(banner)), h("div", bannerHeaderInlineStyle(banner), !!useLogo && h("img", _extends({
    alt: "",
    src: useLogo
  }, bannerHeaderInlineStyleLogo(banner, useRetina))), !!useHeadline && h("div", commonInlineStyleHeaderHeadline(banner, false), useHeadline), (!!showCloseIcon || !!activeAction) && h(BannerCloseIcon, null)));
});
export { BannerHeader };